import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SalesResponseModel } from '@/types'

export const getSalesMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<SalesResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/sales`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
